import { connect } from "react-redux";
import * as creditSettlementActions from "./actions";
import * as usersActions from "../../services/users/actions";

function mapStateToProps(state) {
  return {
    creditSettlement: state.creditSettlement,
    accountInfos: state.users.accountInfos,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSettlements: (paidOut, exported) => {
      dispatch(creditSettlementActions.get_settlements(paidOut, exported));
    },
    getAccountInfosByAccountIds: (accountIds, fetchSSN) => {
      dispatch(usersActions.get_account_infos_for_users(accountIds, fetchSSN));
    },
  };
}

const creditSettlementConnector = connect(mapStateToProps, mapDispatchToProps);
export default creditSettlementConnector;
